<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <fcl-search-bar
          :is-manage-module="true"
          :filter="filter"
          :show-expiration-date="true"
          @onLevelChanged="onLevelChanged"
          @simSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
          @onGridRefresh="gridRefresh"
        >
          <template slot="operations">
            <el-button no="exportToExcel" type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
          </template>
        </fcl-search-bar>
        <fcl-data-grid
          config-module="221500"
          :grid-options="gridOptions"
          :show-approve="true"
          :show-history="true"
          :filter="filter"
          :row-data="rowData"
        />
      </div>
      <price-dialog
        :visible="priceDialog.visible"
        :price="priceDialog.price"
        :price-addon="priceDialog.priceAddon"
        :is-dangerous="priceDialog.isDangerous"
        :un-no="priceDialog.unNo"
        :etd-date="priceDialog.etdDate"
        :level="priceDialog.level"
        @close="onPriceDialogClose"
      />
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryHistoryPriceFcl
} from '@/api/price/priceFcl'
import URL from '@/api/urlTranslator'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import DateUtils from '@/utils/dateUtils'
import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import { exportExcel } from '@/utils/tableDataExportUtils'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import PriceDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/PriceDialog'
import FclDataGrid from '@/views/cargo/v0/Price/components/grid/fclDataGrid'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'PriceFCLLog',
  components: {
    FclDataGrid,
    PriceDialog,
    QuotationDetailDialog,
    FclSearchBar
  },
  data() {
    return {
      URL,
      rowData: [],
      showLevel: true, // 是否显示运价等级
      authedLevel: 99,
      targetLevel: 0,
      tenantUtil: null,
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: '',
        endDate: '',
        dangerous: false,
        isAddon: false,
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false,
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        createDateTo: '',
        expirationBeginDate: '',
        expirationEndDate: ''
      },
      proxy: {},
      quotationDetail: { // 详情
        quotation: null,
        visible: false,
        isEditing: false,
        showDetail: false
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      gridParams: {},
      gridApi: null,
      priceDialog: {
        visible: false,
        isDangerous: false,
        level: 99,
        etdDate: '',
        price: null,
        priceAddon: null
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      this.authedLevel = this.getAuthedLevel()
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PFDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PFDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PFDA_*_2'])) {
        return 2
      }
      return 99
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      this.loadingEnd()
      const _resMap = res.data
      this.fullscreenLoading.close()
      if (_resMap && _resMap.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        return
      }
      const count = _resMap.length
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        _resMap.pop()
      }
      this.rowData = _resMap
      this.gridOptions.api.clearFocusedCell()
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.fullscreenLoading = getLoading()
      queryHistoryPriceFcl(data).then((res) => { this.handleQueryData(res) }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    onPriceDialogClose() {
      this.priceDialog.visible = false
      this.priceDialog.data = {}
    },
    onLevelChanged(searchLevel) {
      this.rowData = []
    },
    onRowDoubleClicked(e) {
      const data = e.data
      const { showLevel, filter, authedLevel, targetLevel, priceDialog, proxy } = this
      if (data) {
        if (showLevel && filter.level && filter.level === '0') {
          if (authedLevel > targetLevel) {
            this.$message.warn(this.$t('Price.YourPermissionIsNotEnough'))
            priceDialog.visible = false
            return
          }
        }
        priceDialog.isDangerous = !proxy.hasOwnProperty('priceNo') ? filter.dangerous : false
        priceDialog.unNo = !proxy.hasOwnProperty('priceNo') ? filter.txtUnNo : ''
        priceDialog.level = showLevel ? targetLevel : authedLevel
        priceDialog.price = data
        priceDialog.priceAddon = data.isAddon ? data : null
        priceDialog.etdDate = filter.beginDate || null
        priceDialog.visible = true
      }
    },
    gridRefresh() {
      this.gridOptions.api.refreshCells({ force: true })
    },
    exportToExcel() {
      const fileName = PriceUtils.getFileName('PriceFCL')
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const rows = selectedRows.length === 0 ? this.rowData : selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns])
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

